<template>
	<nta-dialog
		:show="compProps.show"
		height="auto"
		width="25em"
		:title="symbolsStore.GUILabel('11c99595-e831-4663-9473-0a4887325a1f')"
		max-title-width="70%"
		:symbol-lang="domainStore.languagePreference"
		@close="() => cancel()"
	>
		<v-container>
			<LanguageSelectorFlags
				:lang="domainStore.languagePreference"
				@select="(l: LanguageCode) => domainStore.languagePreference = l "
			/>
		</v-container>
	</nta-dialog>
</template>

<script lang="ts" setup>
import LanguageSelectorFlags from "./LanguageSelectorFlags.vue";
import type { LanguageCode } from "@lr-notitia/notitia-operator/schemas";
import { useDomainStore } from "../store/domain";
import { useSymbolsStore } from "../store/symbols";

const domainStore = useDomainStore();
const symbolsStore = useSymbolsStore();

const compProps = defineProps<{
	show: boolean;
}>();
const emits = defineEmits(["cancel"]);

function cancel(): void {
	emits("cancel");
}
</script>

<style scoped lang="scss"></style>
